const sharedClasses =
    "relative inline-flex items-center font-heading justify-center whitespace-nowrap rounded text-base font-bold uppercase leading-[18px] border border-transparent transition-colors active:ring-4 disabled:opacity-25 disabled:cursor-not-allowed py-[14px] px-[60px] text-lg leading-[24px]";

export const buttonVariants = {
    primary: {
        solidClasses: `${sharedClasses} bg-brand-tertiary text-brand-white border-brand-tertiary hover:bg-brand-tertiary-darken active:bg-brand-tertiary-darken active:ring-brand-info`,
    },
    secondary: {
        solidClasses: `${sharedClasses} bg-brand-white text-brand-primary border-brand-primary hover:bg-brand-primary hover:text-brand-white active:bg-brand-white active:text-brand-primary active:ring-brand-info`,
    },
};
